import React from 'react';
import Flex from '@wix/da-ds/pkg/Flex';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import TierPricePerMonth from '../TierPricePerMonth';
import s from './TierPriceWithBadge.scss';
var TierPriceWithBadge = function (_a) {
    var price = _a.price, showPlaceholder = _a.showPlaceholder, className = _a.className;
    return (React.createElement(Flex, { alignItems: "center", className: className },
        React.createElement(PromoBadge, { badgeType: "tier", size: 24, className: s['badge'] }),
        showPlaceholder && !price ? (React.createElement("span", { className: s['placeholder'] })) : (React.createElement(TierPricePerMonth, { price: price }))));
};
TierPriceWithBadge.displayName = 'TierPriceWithBadge';
export default TierPriceWithBadge;
//# sourceMappingURL=TierPriceWithBadge.js.map